import PedidoAnexoService from "@/services/PedidoAnexoService";

export const pedidoAnexo = {
  namespaced: true,
  state: {
    pedidoAnexo: {},
  },
  actions: {
    getPedidoAnexo({ commit }, payload) {
      return PedidoAnexoService.GetPedidoAnexo(payload).then(
        (pedidoAnexo) => {
          return Promise.resolve(pedidoAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoAnexo({ commit }, payload) {
      return PedidoAnexoService.PostPedidoAnexo(payload).then(
        (pedidoAnexo) => {
          return Promise.resolve(pedidoAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoAnexo({ commit }, payload) {
      return PedidoAnexoService.PutPedidoAnexo(payload).then(
        (pedidoAnexo) => {
          return Promise.resolve(pedidoAnexo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoAnexo({ commit }, payload) {
      return PedidoAnexoService.DeletePedidoAnexo(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoAnexoOData({ commit }, payload) {
      return PedidoAnexoService.GetPedidoAnexoOData(payload).then(
        (pedidoAnexo) => {
          return Promise.resolve(pedidoAnexo);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoAnexo;
